(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loyalty-tier-progress"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // --- Defaults (iconify URLs) used when no merchant asset is uploaded ---
    var TIER_ICONS = {
      0: 'https://api.iconify.design/mdi/medal-outline.svg?color=%23c8102e',
      1: 'https://api.iconify.design/mdi/trophy-outline.svg?color=%23c8102e',
      2: 'https://api.iconify.design/mdi/crown-outline.svg?color=%23c8102e',
    };
    var TIER_EMOJI = { 0: '🎖️', 1: '🏆', 2: '👑' };

    // Default title fallback used when the setting is blank
    var topperTitle = 'Rewards Status:';

    // Read merchant-configurable values from the JSON config block rendered by Liquid.
    // The block is present in the section markup regardless of theme editor state,
    // so this is safe to run at IIFE execution time (script runs after section HTML).
    var configEl = document.querySelector('[data-loyalty-tier-icons]');
    if (configEl) {
      try {
        var config = JSON.parse(configEl.textContent);
        // Merge uploaded icon URLs over the iconify defaults (only keys present in config)
        if (config[0]) TIER_ICONS[0] = config[0];
        if (config[1]) TIER_ICONS[1] = config[1];
        if (config[2]) TIER_ICONS[2] = config[2];
        // Override title only when the setting has a non-empty value
        if (config.title) topperTitle = config.title;
      } catch (e) {
        // JSON parse failure — proceed with hardcoded defaults; nothing is broken
        console.warn('[loyalty-tier-progress] Could not parse icon config:', e);
      }
    }

    function buildTopper() {
      var wrap = document.querySelector('.lion-tier-progress');
      var section = document.querySelector('.lion-tier_progress');
      // Guard: exit if widget not present, or topper already injected (covers
      // both normal page and theme-editor re-renders).
      if (!wrap || !section || section.querySelector('.homage-tier-topper')) return;

      var m = wrap.className.match(/lion-tier-progress--current-tier-(\d+)/);
      var currentTier = m ? parseInt(m[1], 10) : 0;

      var nameEl = document.querySelector(
        '.lion-tier-progress__bar-section--current .lion-tier-progress__bar-section__tier-name'
      );
      var tierName = nameEl ? nameEl.textContent.trim() : 'Rookie';

      var topper = document.createElement('div');
      topper.className = 'homage-tier-topper';

      var h = document.createElement('h2');
      h.className = 'homage-tier-topper__title';
      h.textContent = topperTitle;

      var p = document.createElement('p');
      p.className = 'homage-tier-topper__name';
      p.textContent = tierName;

      var iconWrap = document.createElement('div');
      iconWrap.className = 'homage-tier-topper__icon';

      var img = document.createElement('img');
      img.alt = tierName + ' status icon';
      img.src = TIER_ICONS[currentTier] || TIER_ICONS[0];
      img.addEventListener('error', function () {
        img.style.display = 'none';
        var span = document.createElement('span');
        span.className = 'homage-emoji';
        span.textContent = TIER_EMOJI[currentTier] || TIER_EMOJI[0];
        iconWrap.appendChild(span);
      });
      iconWrap.appendChild(img);

      topper.appendChild(h);
      topper.appendChild(p);
      topper.appendChild(iconWrap);
      section.insertBefore(topper, section.firstChild);
    }

    function init() {
      // If LoyaltyLion has already injected its widget by the time our script runs,
      // build the topper immediately. Otherwise, observe the body for async injection
      // and disconnect after 15 s to avoid a zombie observer on pages without the widget.
      if (document.querySelector('.lion-tier-progress')) {
        buildTopper();
        return;
      }
      var obs = new MutationObserver(function () {
        if (document.querySelector('.lion-tier-progress')) {
          buildTopper();
          obs.disconnect();
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        obs.disconnect();
      }, 15000);
    }

    // Run after DOM is ready (handles both defer-loaded and inline-executed scenarios)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Theme-editor: re-run init when this section is reloaded by the editor.
    // buildTopper()'s existing `.homage-tier-topper` guard prevents duplicate toppers
    // if the widget is still present from the previous render. A fresh observer is
    // started only when the widget element is also absent (clean re-render).
    document.addEventListener('shopify:section:load', function (event) {
      // Re-read the config block — it may have been updated if the merchant changed
      // an icon or title setting that triggered the section reload.
      var reloadedConfigEl = document.querySelector('[data-loyalty-tier-icons]');
      if (reloadedConfigEl) {
        try {
          var reloadedConfig = JSON.parse(reloadedConfigEl.textContent);
          if (reloadedConfig[0]) TIER_ICONS[0] = reloadedConfig[0];
          if (reloadedConfig[1]) TIER_ICONS[1] = reloadedConfig[1];
          if (reloadedConfig[2]) TIER_ICONS[2] = reloadedConfig[2];
          if (reloadedConfig.title) topperTitle = reloadedConfig.title;
        } catch (e) {
          console.warn('[loyalty-tier-progress] Could not parse reloaded icon config:', e);
        }
      }
      init();
    });
  })();

  (function () {
    function toInt(el) {
      if (!el) return NaN;
      return parseInt(el.textContent.replace(/[^0-9]/g, ''), 10);
    }

    function getBalance() {
      // Read the member's available points straight from the header DOM.
      var el = document.querySelector('.lion-header__your-points');
      var n = toInt(el);
      return isNaN(n) ? null : n;
    }

    function applyAffordability() {
      var balance = getBalance();
      if (balance === null) return; // header not rendered yet; observer will retry

      document.querySelectorAll('.lion-redeem .lion-reward-item--gift-card').forEach(function (card) {
        var cost = toInt(card.querySelector('.lion-reward-item__cost .value'));
        if (isNaN(cost)) return;
        card.classList.toggle('is-unaffordable', balance < cost);
      });
    }

    // Run once, then watch for LoyaltyLion (re)rendering the section/header.
    applyAffordability();

    var root = document.querySelector('.lion-integrated-page') || document.body;
    if (root) {
      new MutationObserver(function () {
        applyAffordability();
      }).observe(root, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
